import {
  type ForwardedRef,
  forwardRef,
  type HTMLAttributes,
  type PropsWithChildren,
} from "react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

type ColumnGroupingCellProps = {
  hasError?: boolean;
} & HTMLAttributes<HTMLButtonElement>;

export const ColumnGroupingCell = forwardRef(
  (
    {
      hasError = false,
      ...restProps
    }: PropsWithChildren<ColumnGroupingCellProps>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return <button ref={ref} css={rootStyles({ hasError })} {...restProps} />;
  },
);

const rootStyles =
  ({ hasError }: { hasError?: boolean }) =>
  ({ colorsV2 }: ExactTheme) =>
    css({
      all: "unset",
      position: "relative",
      height: "100%",
      width: "100%",
      display: "grid",
      placeContent: "center",
      color: hasError ? colorsV2.red[500] : colorsV2.blue[500],
      fontSize: 20,
    });
